/*
  Odenwälder BabyNest: Produktseite
  Dawn aktualisiert beim Variantenwechsel nur Preis, Bestand, SKU und Button. Die Lieferzeit
  (snippets/od-product-delivery.liquid) und die Bilder der Farbkacheln werden hier aus der neu
  geladenen Section übernommen.
*/
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const { sectionId, html } = event.data || {};
    if (!sectionId || !html) return;

    // Lieferzeit und Artikelnummer der neuen Variante übernehmen
    [`OdDelivery-${sectionId}`, `Sku-${sectionId}`].forEach((id) => {
      const source = html.getElementById(id);
      const destination = document.getElementById(id);
      if (source && destination) destination.replaceWith(source);
    });

    // Farbkacheln mit Bild: Bei mehreren Farboptionen (Bundles) zeigt jede Kachel die Kombination mit
    // der aktuellen Auswahl. Dawn rendert die Varianten-Auswahl nicht neu, daher die Kachelbilder
    // aus der neu geladenen Section übernehmen (Zuordnung über das for-Attribut des Labels).
    document.querySelectorAll('.od-variant--color label.od-variant__color[for]').forEach((label) => {
      const image = label.querySelector('.od-variant__image');
      const updated = html.querySelector(`label.od-variant__color[for="${CSS.escape(label.htmlFor)}"] .od-variant__image`);
      if (!image || !updated || image.innerHTML === updated.innerHTML) return;
      image.innerHTML = updated.innerHTML;
      image.setAttribute('style', updated.getAttribute('style') || '');
    });
  });
})();

/*
  Sterne-Bewertung (.od-pdp-rating): Sprung zu den Bewertungen. Findet sich das eingestellte Sprungziel
  nicht (z. B. Judge.me "Cards Carousel" statt "Review Widget", das die ID judgeme_product_reviews setzt),
  wird das nächste Judge.me-Widget auf der Seite angesteuert.
*/
(() => {
  const FALLBACKS = ['#judgeme_product_reviews', '.jdgm-review-widget', '.jdgm-rev-widg', '.jdgm-widget:not(.jdgm-preview-badge)'];

  const findTarget = (hash) => {
    const selectors = hash && hash.length > 1 ? [hash, ...FALLBACKS] : FALLBACKS;
    for (const selector of selectors) {
      let element = null;
      try {
        element = document.querySelector(selector);
      } catch (error) {
        continue;
      }
      // Sterne-Badge neben dem Titel nicht als Ziel nehmen
      if (element && element.offsetParent !== null && !element.closest('.product__info-container')) return element.closest('.shopify-section') || element;
    }
    return null;
  };

  // Nur bei dauerhaft fixierter Navbar deren Höhe abziehen ("on-scroll-up" blendet sie beim Runterscrollen aus)
  const headerOffset = () => {
    const header = document.querySelector('sticky-header');
    const type = header && header.dataset.stickyType;
    return (type === 'always' || type === 'reduce-logo-size' ? header.offsetHeight : 0) + 16;
  };

  // Beim Scrollen laden Bilder weiter oben nach und verschieben das Ziel: so lange nachsteuern,
  // bis es zweimal in Folge an der richtigen Stelle steht (höchstens etwa 4 Sekunden)
  let correction = null;
  const scrollToTarget = (target) => {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const distance = () => target.getBoundingClientRect().top - headerOffset();
    window.scrollTo({ top: window.scrollY + distance(), behavior });

    clearInterval(correction);
    let tries = 0;
    let settled = 0;
    let lastY = -1;
    correction = setInterval(() => {
      tries += 1;
      const moving = Math.abs(window.scrollY - lastY) > 1;
      lastY = window.scrollY;
      if (moving && tries < 20) return;
      if (Math.abs(distance()) <= 4) {
        settled += 1;
      } else {
        settled = 0;
        window.scrollTo({ top: window.scrollY + distance(), behavior });
      }
      if (settled >= 2 || tries >= 20) clearInterval(correction);
    }, 200);
    // Eigenes Scrollen (Rad, Touch, Tasten) beendet die Nachkorrektur
    ['wheel', 'touchstart', 'keydown'].forEach((type) =>
      window.addEventListener(type, () => clearInterval(correction), { once: true, passive: true })
    );
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.od-pdp-rating');
    if (!link) return;
    const hash = link.getAttribute('href') || '';
    if (!hash.startsWith('#')) return;
    const target = findTarget(hash);
    if (!target) return;
    event.preventDefault();
    scrollToTarget(target);
    history.replaceState(null, '', hash);
  });

  // Aufruf mit #judgeme_product_reviews in der URL: Judge.me lädt nach, daher kurz auf das Widget warten
  const link = document.querySelector('a.od-pdp-rating');
  const hash = link && link.getAttribute('href');
  if (!hash || !hash.startsWith('#') || window.location.hash !== hash) return;
  let tries = 0;
  const timer = setInterval(() => {
    const target = findTarget(hash);
    if (target || ++tries > 20) clearInterval(timer);
    if (target) scrollToTarget(target);
  }, 250);
})();

/*
  Popup "Ganze Seite im Popup anzeigen" (Block popup, Einstellung od_full_page): lädt beim ersten Öffnen
  (bzw. schon beim Überfahren des Links) die verknüpfte Seite und übernimmt deren Sektionen aus
  #MainContent, also ohne Navbar und Footer. Stylesheets der Sektionen kommen mit, Skripte nicht.
*/
if (!customElements.get('od-page-popup')) {
  customElements.define(
    'od-page-popup',
    class OdPagePopup extends HTMLElement {
      connectedCallback() {
        this.modal = this.closest('modal-dialog');
        if (!this.modal) return;

        this.observer = new MutationObserver(() => {
          if (this.modal.hasAttribute('open')) this.load();
        });
        this.observer.observe(this.modal, { attributes: true, attributeFilter: ['open'] });

        const opener = document.querySelector(`modal-opener[data-modal="#${CSS.escape(this.modal.id)}"]`);
        if (opener) {
          ['pointerenter', 'focusin', 'touchstart'].forEach((type) =>
            opener.addEventListener(type, () => this.load(), { once: true, passive: true })
          );
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      load() {
        if (this.loading) return;
        this.loading = fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((text) => {
            const page = new DOMParser().parseFromString(text, 'text/html');
            const main = page.getElementById('MainContent') || page.querySelector('main');
            if (!main || !main.children.length) throw new Error('empty');
            this.render(main);
          })
          .catch(() => {
            // Link zur Seite bleibt stehen, nur der Ladehinweis verschwindet
            this.classList.add('od-page-popup--failed');
          });
      }

      render(main) {
        // Schema (z. B. FAQPage) gehört zur eigenen Seite, Skripte laufen hier ohnehin nicht
        main.querySelectorAll('script').forEach((script) => script.remove());

        // Einblend-Animationen würden im Popup nie ausgelöst
        main.querySelectorAll('.scroll-trigger').forEach((element) => {
          element.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in', 'animate--fade-in');
        });

        // Die Produktseite hat schon eine H1
        main.querySelectorAll('h1').forEach((heading) => {
          const replacement = document.createElement('h2');
          [...heading.attributes].forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
          replacement.innerHTML = heading.innerHTML;
          heading.replaceWith(replacement);
        });

        // Leere Akkordeon-Zeilen ausblenden (wie in sections/collapsible-content.liquid)
        main.querySelectorAll('.accordion').forEach((accordion) => {
          const content = accordion.querySelector('.accordion__content');
          if (content && content.innerHTML.trim() === '') accordion.style.display = 'none';
        });

        // Nur die Sektionen (samt Stylesheets) übernehmen, nicht z. B. den Breadcrumb der Seite
        let nodes = [...main.children].filter((node) => node.matches('.shopify-section, link[rel="stylesheet"], style'));
        if (!nodes.some((node) => node.matches('.shopify-section'))) nodes = [...main.childNodes];
        this.replaceChildren(...nodes.map((node) => document.adoptNode(node)));
        this.classList.add('od-page-popup--loaded');
      }
    }
  );
}
